/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from '../../types/fs-core'
import { brand } from '../../redux/app-selectors'

interface IconProps {
  glyph: any
  color: string
  size: 8 | 10 | 13 | 20 | 24 | 26 | 32 | 36 | 44 | 45 | 48 | 64 | 92
  desktopSize?: 24 | 32 | 40 | 42 | 44 | 48 | 65 | 92
  fill?: string
  brand: 'money' | 'uswitch' | 'confused'
  ariaLabel: string
}

const iconVersion = 21

const Icon: React.FC<IconProps> = ({ glyph, size, desktopSize, color, fill, brand, ariaLabel }) => {
  const basePath = process.env.IN_STORYBOOK ? `/icons/${brand}` : `/fs-core-assets/icons/${brand}`
  const url = `${basePath}/${glyph}.svg?v=${iconVersion}#${glyph}`
  const iconSize = desktopSize ? desktopSize : size
  const sizeClassName = desktopSize
    ? `DynamicIcon__${size} DynamicIcon__desktop__${desktopSize}`
    : `DynamicIcon__${size}`

  const svgOptions = {
    ...(brand === 'confused' ? { viewBox: `0 0 ${iconSize} ${iconSize}` } : {}),
    stroke: color,
    fill,
    color,
  }

  return (
    <svg
      className={sizeClassName}
      role={ariaLabel ? undefined : 'presentation'}
      aria-label={ariaLabel}
      {...svgOptions}
    >
      <use href={url} />
    </svg>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    brand: brand(state),
    ...props,
  }
})(Icon)
